import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IoMdArrowDropdown, IoMdArrowDropup } from 'react-icons/io';
import { FadeInImage } from '../../../../components/FadeInImage';
import { Avatar } from '../Avatar';
import './style.scss';
import { getRegion } from '../../../../utils/Region';
import { clearKeywordSearch } from '../../../NewSearchPage/redux/actions/searchActions';
import { useNavigate } from 'react-router-dom';
import { MenuAvatar } from 'containers/MenuAvatar';

export const MobileMenu = ({ showDropDownMenu, isDropDownActive }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { search_menu_option_button_popularSearches } = useSelector(
    state => state.asset,
  );

  const handleShowDropDown = () => showDropDownMenu(prev => !prev);
  const redirectToSearch = () => {
    //Accion para limpiar la keyword
    dispatch(clearKeywordSearch());
    navigate(`/${getRegion()}/search`);
  };

  return (
    <div className="cv-mobile-menu">
      <label onClick={handleShowDropDown} className="cv-mobile-menu__explorar">
        Explorar
        {isDropDownActive ? (
          <IoMdArrowDropup size={16} style={{ marginLeft: 5 }} />
        ) : (
          <IoMdArrowDropdown size={16} style={{ marginLeft: 5 }} />
        )}
      </label>
      <div className="cv-mobile-menu__right">
        <FadeInImage
          imageSrc={search_menu_option_button_popularSearches}
          imageAlt={'glass'}
          classNames={['cv-mobile-menu__right__search']}
          width="22"
          height="22"
          onClick={redirectToSearch}
        />
        <MenuAvatar
          showDropDownMenu={showDropDownMenu}
          isDropDownActive={isDropDownActive}
        />
      </div>
    </div>
  );
};
